import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

function NameInput({ 
  name,
  onChangeName
}) {
  const { t } = useTranslation();
  const [nameCheck, setNameCheck] = useState('');
  
  const onBlur = useCallback(() => {
    let result = 'success';
    if (!name) result = 'fail';

    setNameCheck(result);
  }, [name]);

  return (
    <>
      <div className="input_box white_box">
        <input
          name="name"
          type="text"
          placeholder={t("MY_02_05.msg033")}
          onBlur={onBlur}
          onChange={onChangeName}
        />
        {
          nameCheck && (
            <div className="r_area">
              {
                nameCheck === 'success' 
                  ? <img src="./static/images/icon/ic_check.svg" alt="" />
                  : <button type="button"><img src="./static/images/icon/ic_error.svg" alt="" /></button>
              }
            </div>
          )
        }
      </div>
      {name && <div className="red_txt fs12_10">{t("MY_02_05.msg032")}</div> }
    </>
  );
}

export default NameInput;